import React, { useState } from 'react'
import Razorpay from './razorpay/Razorpay'
import PayPal from './paypal/Paypal'
// import { CreateOrder, getStatusById } from '../utlis/utlis'
// import CashFree from './cashfree/CashFree'
import useEffectOnce from '../hooks/useEffectOnce'
import AffordabilityWidget from './Payu'
import CashFree from './cashfree/CashFree'
// import Stripe from './stripe'
import StripeCheckout from './stripe'
import Verifone from './Verifone'
// import { Bounce, toast } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css';

interface GatewaysProps {
  payload: any
}

export default function Gateways({ payload }: GatewaysProps): JSX.Element {
  let [scriptLoaded, setScriptLoaded]=useState(false)

  // const getEnvironmentUrl = (env: string) => {
  //   const baseUrls: any = {
  //     local: 'http://localhost:8002',
  //     qa: 'https://qa-ks-pay-openapi.p2eppl.com',
  //     dev: 'https://dev-ks-pay-openapi.p2eppl.com',
  //     SANDBOX: 'https://pay-sandboxapi.kalp.studio',
  //     LIVE: 'https://pay-liveapi.kalp.studio',
  //   }
  //   return baseUrls[env]
  // }
  // headers.environment_url = getEnvironmentUrl(headers?.environment)

  // const [gateway, setGateway] = React.useState<string | null>(payload?.gateway)
  // const [order, setOrder] = React.useState<any>(null)
  // const [clientSecret, setClientSecret] = React.useState<string>('')
  // const [orderCreated, setOrderCreated] = React.useState<boolean>(false)
  // const [txId, setTxId] = React.useState<string>(payload?.pe_txnId)
  const {
    // order = '',
    // clientSecret = '',
    // orderCreated = false,
    txId = payload?.pe_txnId,
    gateway = payload?.gateway,
  } = payload || {}

  // const getStatus = async () => {
  //   try {
  //     // const headers = JSON.parse(localStorage.getItem('headers') || '{}');
  //     const result = await getStatusById(txId, headers)
  //     const response = result?.data?.result
  //     if (response) {
  //       // transactionStatusCallback({ txId, status: response?.status })
  //     }
  //   } catch (err) {
  //     console.error({ err })
  //     // transactionStatusCallback({ txId, status: 'PENDING' })
  //   }
  // }

  // const createOrder = async () => {
  //   // const headers = JSON.parse(localStorage.getItem('headers') || '{}');

  //   try {
  //     const result = await CreateOrder(payload, headers)
  //     // console.log(result)
  //     if (result?.data?.result) {
  //       // localStorage.removeItem('call')

  //       const response = result?.data?.result
  //       setOrder(response)
  //       setGateway(response.gateway)
  //       setTxId(response.pe_txnId)

  //       const signature =
  //         response?.clientSecret ?? response?.ecToken ?? response?.payment_session_id ?? response?.payment_url
  //       setClientSecret(signature)
  //       setOrderCreated(true)
  //     }
  //   } catch (error: any) {
  //     // localStorage.removeItem('call')

  //     console.log(error?.response?.data?.message)
  //     if (typeof error !== 'string') {
  //       toast.error(error?.response?.data?.message, {
  //         position: 'top-right',
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //         theme: 'light',
  //         transition: Bounce,
  //         onClose: () => window.location.reload(),
  //       })
  //     }
  //     console.error('Error creating order:', error)
  //   }
  // }

  // React.useEffect(() => {
  //   const url = new URL(window.location.href)
  //   const params = new URLSearchParams(url.search)
  //   if (params.get('txnId')) {
  //     // getStatus()
  //   }
  // }, [window.location.href])

  useEffectOnce(() => {
    // setCall(true)
    // localStorage.setItem('call','true')
    const script = document.createElement('script')
    script.src = 'https://www.2checkout.com/checkout/api/2co.min.js' // Replace with your script URL
    script.async = true

    script.onload = () => {
      // createOrder()
      setScriptLoaded(true);
      // Optionally, you can do something after the script has loaded
    }

    script.onerror = () => {
      console.error('Script failed to load.')
      // Handle script load error if needed
    }

    document.body.appendChild(script)
  })

  // if (!orderCreated) {
  //   return <div>Loading...</div>
  // }

  const callAfterPayment = (data:any) => {
    
  switch(payload?.gateway)
  {

    case 'RAZORPAY':{
      window.location.href = `${payload?.redirectUrl}?kspay_id=${txId}&payment_status=${data?.status?'Success':'Failed'}&provider_payment_id=${data?.id}`
  break;
    }
    case 'PAYPAL':{
      window.location.href = `${payload?.redirectUrl}?kspay_id=${txId}&payment_status=${data?.status?'Success':'Failed'}&provider_payment_id=${data?.id}`
  break;
    }
    case 'STRIPE':{
      window.location.href = `${payload?.redirectUrl}?kspay_id=${txId}&payment_status=${data?.status?'Success':'Failed'}&provider_payment_id=${data?.id}`
  break;
    }
    default:{
      window.location.href = `${payload?.redirectUrl}?txId=${txId}`
  break;


    }
  }
  }

  return (
    <>
      {gateway === 'RAZORPAY' ? (
        <Razorpay
          payload={payload}
          // headers={headers}
          // order={order}
          // transactionStatusCallback={()=>{console.log('callback')}}
          // clientSecret={clientSecret}
          callAfterPayment={callAfterPayment}
        />
      ) : gateway === 'PAYPAL' ? (
        <PayPal
          payload={payload}
          // headers={headers}
          // order={order}
          // transactionStatusCallback={transactionStatusCallback}
          // clientSecret={clientSecret}
          callAfterPayment={callAfterPayment}
          // headers={headers}
        />
      ) : gateway === 'CASHFREE' ? (
        <>
        <CashFree
          payload={payload}
          // headers={headers}
          // callAfterPayment={getStatus}
        />
        </>
      ) : gateway === 'PAYU' ? (
        <>
        {console.log(payload?.details.initiateTransaction.key)}
        <AffordabilityWidget
          key={payload?.details.initiateTransaction.key}
          // headers={headers}
          amount={1}
          payload={payload}
          // transactionStatusCallback={transactionStatusCallback}
          // clientSecret={clientSecret}
          // redirect_url={`${window.location.origin}?txnId=${txId}`}
          // callAfterPayment={getStatus}
        />
        </>):
         gateway === 'STRIPE' ? (
          <>
          {console.log(payload)}
          <StripeCheckout
          callAfterPayment={callAfterPayment}
            // key={payload?.details.initiateTransaction.key}
            // headers={headers}
            // amount={1}
            payload={payload}
            // transactionStatusCallback={transactionStatusCallback}
            // clientSecret={clientSecret}
            // redirect_url={`${window.location.origin}?txnId=${txId}`}
            // callAfterPayment={getStatus}
          />
          </>):
         gateway === 'VERIFONE' ? (
          <>
          {console.log(payload)}
          {
            scriptLoaded &&
          <Verifone
            // key={payload?.details.initiateTransaction.key}
            // headers={headers}
            // amount={1}
            // transactionStatusCallback={transactionStatusCallback}
            // clientSecret={clientSecret}
            // redirect_url={`${window.location.origin}?txnId=${txId}`}
            // callAfterPayment={getStatus}
          />
          }
          </>):(
        <div>Unsupported gateway</div>
      )}
    </>
  )
}
